import { render, staticRenderFns } from "./TeacherTemplates.vue?vue&type=template&id=775c4536&"
import script from "./TeacherTemplates.vue?vue&type=script&lang=js&"
export * from "./TeacherTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports